import type { Routes } from '@angular/router';
import { LoginComponent } from '@auth/pages/login/login.component';
import { NoAccessPage } from '@auth/pages/no-access/no-access.page';
import { ResetPasswordComponent } from '@auth/pages/reset-password/reset-password.component';
import { ForgotPasswordComponent } from '@auth/pages/forgot-password/forgot-password.component';
import { APP_ROUTE_TITLE_PREFIX } from '@shared/constants/app-brand.const';

/**
 * Rutas relacionadas con la autenticación de usuarios en la aplicación.
 */
export const AUTH_ROUTES = {
  root: 'auth',
  login: 'login',
  noAccess: 'sin-accesos',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
};

/**
 * Define las rutas de autenticación para Indómito Hub.
 * Incluye la ruta principal y sus rutas hijas, como la de inicio de sesión, recuperación y restablecimiento de contraseña.
 */
export const authRoutes: Routes = [
  {
    path: '',
    title: `${APP_ROUTE_TITLE_PREFIX} | Acceso`,
    children: [
      {
        path: AUTH_ROUTES.login,
        component: LoginComponent,
      },
      {
        path: AUTH_ROUTES.noAccess,
        component: NoAccessPage,
        title: `${APP_ROUTE_TITLE_PREFIX} | Sin accesos`,
      },
      {
        path: AUTH_ROUTES.forgotPassword,
        component: ForgotPasswordComponent,
      },
      {
        path: AUTH_ROUTES.resetPassword,
        component: ResetPasswordComponent,
      },
    ],
  },
];
